module.exports = __webpack_public_path__ + "img/criancaesperanca.3ff11a0c.png";